import useAuth from "../../hooks/useAuth";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { routes } from "../../routes";

const DeniedLogin = () => {
  const { auth } = useAuth();
  const location = useLocation();

  return auth?.roles ? (
    <Navigate to={routes.home} state={{ from: location }} replace={true} />
  ) : (
    <Outlet />
  );
};

export default DeniedLogin;
